export default "__VITE_PUBLIC_ASSET__bb4bd701__"